/**
 * Campaigns is an analytics route, so its visible Shop scope can differ from
 * the ambient operational Shop. A single visible Shop is an explicit choice
 * and must own any Smart Creation plan launched from that page.
 */
export function resolveSmartCreationShopId(
  scopeShopIds: string[],
  currentShopId: string | null,
): string | null {
  return scopeShopIds.length === 1 ? (scopeShopIds[0] ?? null) : currentShopId;
}
